import React, { Key, MouseEvent, ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';

export enum PageButtonType {
  PREV = '<',
  NEXT = '>',
  ELLIPSIS = '...',
}

export type Props = {
  children?: ReactNode;
  index?: number | string;
  isActive?: boolean;
  key?: Key;
  onEllipsisClick?: () => void;
  onPageChange?: (page: number | string) => void;
  page?: number | string;
  pageUrlFn?: (page: number | string) => string;
  pageUrlPrefix?: string;
  pageUrlSuffix?: string;
  type?: PageButtonType;
};

export const PageButton = (props: Props) => {
  const {
    children,
    isActive,
    onEllipsisClick = () => null,
    onPageChange = () => null,
    page,
    pageUrlFn,
    pageUrlPrefix,
    pageUrlSuffix = '',
    type,
  } = props;

  const btnText = type || page;
  const isEllipsis = type === PageButtonType.ELLIPSIS;

  const getPageUrl = () => {
    if (isEllipsis || !page) return undefined;

    const customUrl = pageUrlFn?.(page);
    if (customUrl !== undefined) return customUrl;

    return `${pageUrlPrefix}/${page}${pageUrlSuffix}`;
  };

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    if (isEllipsis) return onEllipsisClick();
    if (!page) return false;
    return onPageChange(page);
  };

  return (
    <Link
      className={cx('page-button', { active: isActive, ellipsis: isEllipsis })}
      href={getPageUrl()}
      onClick={handleClick}
    >
      {children ?? btnText}
    </Link>
  );
};

const Link = styled.a`
  border-radius: 3px;
  display: inline-block;
  margin: 2px;
  padding: 7px 14px;
  text-decoration: none;
  user-select: none;
  background-color: rgb(215, 215, 215);
  color: rgb(136, 136, 136);
  text-transform: capitalize;

  &:not(.ellipsis):not(.active) {
    cursor: pointer;
  }

  &.active,
  &:hover {
    background-color: rgb(136, 136, 136);
    color: rgb(255, 255, 255);
    text-decoration: none;
  }
`;
